import {
  HOME_CHANGE_PROJECT_STATUS_BEGIN,
  HOME_CHANGE_PROJECT_STATUS_SUCCESS,
  HOME_CHANGE_PROJECT_STATUS_FAILURE,
  HOME_CHANGE_PROJECT_STATUS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderAuthHeader } from '../../common/utils/auth';

export function changeProjectStatus(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_CHANGE_PROJECT_STATUS_BEGIN,
    });
    console.log('args changeProjectStatus :>> ', args);
    const config = builderAuthHeader();
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_ORGANIZATION_ENGINE_URL}projects/${args.projectId}/state`,
        {},
        config,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CHANGE_PROJECT_STATUS_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: HOME_CHANGE_PROJECT_STATUS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeProjectStatusError() {
  return {
    type: HOME_CHANGE_PROJECT_STATUS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CHANGE_PROJECT_STATUS_BEGIN:
      return {
        ...state,
        changeProjectStatusPending: true,
        changeProjectStatusError: null,
      };

    case HOME_CHANGE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        changeProjectStatusPending: false,
        changeProjectStatusError: null,
        project: action.data,
      };

    case HOME_CHANGE_PROJECT_STATUS_FAILURE:
      return {
        ...state,
        changeProjectStatusPending: false,
        changeProjectStatusError: action.data.error,
      };

    case HOME_CHANGE_PROJECT_STATUS_DISMISS_ERROR:
      return {
        ...state,
        changeProjectStatusError: null,
      };

    default:
      return state;
  }
}
